import { RoutePath, type RoutePaths } from "@/lib/routes"

export const navigatorRoutesPaths = {
    meterDetails: RoutePath.create("/navigator"),
    meterDetailsWithPartner: RoutePath.create("/navigator/:partnerSlug"),
    providerCalendar: RoutePath.create("/navigator/option-tarifaire"),
    effyEnergyLandscape: RoutePath.create("/navigator/paysage-energetique-offre-effy"),
    energyLandscape: RoutePath.create("/navigator/paysage-energetique"),
    energyLandscapeNew: RoutePath.create("/navigator/paysage-energetique-new"),
    meterReadings: RoutePath.create("/navigator/autoreleve"),
    electricityMeterIneligible: RoutePath.create("/navigator/ineligible"),
    gasMeterIneligible: RoutePath.create("/navigator/pce-ineligible"),
    addressIneligible: RoutePath.create("/navigator/adresse-ineligible"),
    quote: RoutePath.create("/navigator/devis"),
    personalDetails: RoutePath.create("/navigator/informations-personnelles"),
    paymentDetailsUnpaidBills: RoutePath.create(
        "/navigator/informations-de-paiement/erreur-paiement"
    ),
    confirmation: RoutePath.create("/navigator/confirmation"),
    resetSession: RoutePath.create(
        "/navigator/reinitialisation?partnerSlug=:partnerSlug&affiliate=:affiliate"
    ),
} as const satisfies RoutePaths
